import { render, staticRenderFns } from "./ZoneSelectRederer.vue?vue&type=template&id=8d0e8cf0&"
import script from "./ZoneSelectRederer.vue?vue&type=script&lang=ts&"
export * from "./ZoneSelectRederer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports